import { Breadcrumb, Layout } from 'antd'
import { Link, useRouteMatch, withRouter } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import GraphConsole from 'Components/Graph/GraphConsole'
import FormsContainer from './FormsContainer'
import './index.scss';


function CreateTask ({ history }) {
  const { params: { spaceId, taskId }} = useRouteMatch()

  const { data, isLoading } = useQuery(
    ['weaver-orchestrator'],
    () => Weaver.Plugin.load('weaver-orchestrator')
  )

  return (
    <Layout>
      <Breadcrumb style={{ margin: 20, marginBottom: 0 }}>
        <Breadcrumb.Item>
          { Weaver.getInstance().currentProject()?.name() }
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/${ spaceId }/pipelines/tasks`}>
            Tasks
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          { taskId }
        </Breadcrumb.Item>
      </Breadcrumb>
      {
        !isLoading &&
          <FormsContainer
            data-testid="create-task-form"
            history={history}
            orchestrator={data}
          />
      }
      <GraphConsole
        isHidden={false}
        sparqlOnly={true}
        saveQueryAsView={false}
      />
    </Layout>
  )
}

export default withRouter(CreateTask)
